import API from "lib/api";
import apiRoutes from "lib/api/apiRoutes";
import { useEffect, useState } from "react";
import FileUploadWrapperLoader from "./FileUploadWrapperLoader/FileUploadWrapperLoader";
import { dataQueryStatus } from "utils/formatHandlers";

const { LOADING, ERROR, DATAMODE } = dataQueryStatus;

const FileUploadWrapper = ({
    file,
    setLoading,
    setError,
    setUploadedFileKey,
    useLoader,
    loaderClass,
    children,
    setStatus,
}) => {
    const { file: originalFile } = file || {};
    const { name } = originalFile || {};
    const [isUploading, setIsUploading] = useState(false);
    const errorMessage = "We encountered a error uploading this file"
    const generateUploadLink = async () => {
        try {

            console.log("generating upload link");
            setLoading?.(true);
            setError?.();
            setIsUploading(true);
            setStatus?.(LOADING);
            const url = apiRoutes.generateUploadLink;

            const res = await API.put(
                url,
                {
                    file: name,
                },
                {}
            );

            console.log("uploading link generated", res)
            
            if (res.status === 200) {
                const data = res.data;
                const { fileKey, link } = data?.data || {};
                uploadFile(link, fileKey);
                setStatus?.(DATAMODE);
            }
        } catch (err) {
            setLoading?.(false);
            setError?.(errorMessage);
            setIsUploading(false);
            setStatus?.(ERROR);
        }
    };

    // const uploadFile = async (url, fileKey) => {
    //     try {
    //         console.log("uploading file", url, fileKey);
    //         setLoading?.(true);
    //         setIsUploading(true);
    //         setStatus(LOADING);
    //         const options = {
    //             disableAuthorization: true,
    //         };

    //         const reader = new FileReader();
    //         reader.readAsArrayBuffer(originalFile);
    //         reader.onload = async () => {
    //             const binaryData = reader.result;

    //             console.log("originalFile.type", originalFile.type)
    //             console.log("binaryData", binaryData)
    //             console.log("options", options)
    //             console.log("url", url)
    //             const res = await API.put(`${url}`, binaryData, 
    //                 {
    //                     ...options,
    //                         headers: {
    //                         'Content-Type': 'application/pdf'
    //                     }
    //                 }
    //             );

    //             if (res.status === 200) {
    //                 console.log("file uploaded", res, fileKey, file);
    //                 setUploadedFileKey?.(fileKey, file);
    //                 setLoading?.(false);
    //                 setError?.();
    //                 setIsUploading(false);
    //                 setStatus(DATAMODE);
    //             }
    //         };
    //     } catch (err) {
    //         setError?.(errorMessage);
    //         setLoading?.(false);
    //         setIsUploading(false);
    //         setStatus(ERROR);
    //     }
    // };

    const uploadFile = async (url, fileKey) => {
        try {
            console.log("uploading file", url, fileKey);
            setLoading?.(true);
            setIsUploading(true);
            setStatus(LOADING);
    
            const response = await fetch(url, {
                method: "PUT",
                body: originalFile, // send the originalFile object directly
                headers: {
                    "Content-Type": originalFile.type || "application/pdf", // Important!
                },
            });
    
            if (response.ok) {
                console.log("file uploaded successfully", fileKey, file);
                setUploadedFileKey?.(fileKey, file);
                setError?.();
                setStatus(DATAMODE);
            } else {
                console.error("Upload failed:", await response.text());
                setError?.("Upload failed");
                setStatus(ERROR);
            }
        } catch (err) {
            console.error("Upload error:", err);
            setError?.("Upload failed");
            setStatus(ERROR);
        } finally {
            setLoading?.(false);
            setIsUploading(false);
        }
    };
    

    useEffect(() => {
        if (name) {
            generateUploadLink();
        }
        // eslint-disable-next-line
    }, [name]);

    return (
        <>
            {useLoader ? (
                <FileUploadWrapperLoader
                    {...{ isUploading, loaderClass, children }}
                />
            ) : (
                children
            )}
        </>
    );
};

export default FileUploadWrapper;
